export type SidexaGlass =
  | '64-10-010' //windShield
  | '64-20-010' //lateral
  | '64-35-010' //rearWindow
  | '95-10-015' //lights
  | '51-50-010'; //topWindow
